// @flow

import React from 'react';
import {Field, reduxForm} from 'redux-form';
import BasicFormInput from '../BasicFormInput/BasicFormInput';
import validator from '../../helpers/validator';

const validation = {
  password_confirmation: {rule: 'string|required|min:6|max:255', label: 'Lösenord'},
  password: {rule: 'string|required|confirmed|max:255', label: 'Lösenord'},
};

export type Props = {
  handleSubmit: Function,
};

const PasswordForm = ({handleSubmit}: Props) => (
  <div className="PasswordForm">
    <form onSubmit={handleSubmit}>
      <Field
        name="password_confirmation"
        label="Lösenord"
        component={BasicFormInput}
        type="password" />
      <Field
        name="password"
        label="Repetera lösenord"
        component={BasicFormInput}
        type="password" />
      <button
        type="submit"
        className="button success expanded">
        Spara
      </button>
    </form>
  </div>
);

export default reduxForm({
  form: 'password',
  validate: values => validator(validation, values),
})(PasswordForm);



// WEBPACK FOOTER //
// ./src/components/PasswordForm/PasswordForm.js